<script lang="ts">
  import { replace } from "svelte-spa-router";
  import {
    Button,
    EmptyState,
    Header,
    Hor,
    OffApp,
    OnApp,
    Page,
    Spacer,
    Ver,
  } from "$components";
  import { onMount } from "svelte";
  import { AgreementModel } from "$shared/models/mod.ts";
  import { Decode } from "$shared/lib/query";
  import api, {
    fromApi,
    intoModel,
  } from "$shared/lib/api-parkito2.svelte.ts";

  const query = Decode.query({
    type: Decode.literal<"permit">("permit"),
    agreementId: Decode.text,
  }).or(Decode.query({
    type: Decode.literal<"queue">("queue"),
    applicantId: Decode.text,
  }));
  const agreementReq = fromApi((agreementId: string) =>
    api.getAgreement({ path: { id: agreementId } }).then(
      intoModel(AgreementModel),
    )
  );
  const siteReq = fromApi((siteId: string) =>
    api.siteGet({ path: { id: siteId } })
  );
  $agreementReq.onOk((ag) => $siteReq.load(ag.data.siteId));

  const applicantReq = fromApi((applicantId: string) =>
    api.queueGetApplicant({ path: { id: applicantId } })
  );
  onMount(() => {
    if (query.isOk()) {
      if (query.value.type === "permit") {
        $agreementReq.load(query.value.agreementId);
      } else {
        $applicantReq.load(query.value.applicantId);
      }
    }
  });

  const title = query.value?.type === "permit"
    ? "Parkeringstillstånd"
    : "Intresseanmälan";

  const subTitle = query.value?.type === "permit"
    ? "Tack för ditt köp av parkeringstillstånd!"
    : "Tack för din intresseanmälan!";
  const bodyText = $derived(
    query.value?.type === "permit"
      ? `Du kommer kunna börja nyttja tillståndsplatsen på ${$siteReq.call.data?.name} från och med ${
        $agreementReq.call.data?.getStartDate()?.format("D MMM YYYY")
      } `
      : "Vi kommer att kontakta dig så snart vi har en ledig plats att erbjuda.",
  );

  function handleGoToInventory() {
    if (globalThis.ReactNativeWebView !== undefined) {
      globalThis.ReactNativeWebView.postMessage("goToInventory");
      setTimeout(() => {
        replace("#/store");
      }, 300);
    }
  }
</script>

<Page backButton={false} {title}>
  {#snippet content()}
    {#if query.value}
      <Ver margin="s" gap="m" justify="center">
        <Spacer minSpace="l" />

        <Hor justify="center" margin="l">
          <img
            src="/icons/checkmark-blue-green.svg"
            alt="OK"
            class="inline w-[100px]"
          />
        </Hor>
        <Header size="2">
          {subTitle}
        </Header>
        <p>
          {bodyText}
        </p>
        <p>
          Vänliga hälsningar,<br />
          Parkando
        </p>
        <OffApp>
          <p class="mt-[24px] underline">
            <a href="#/">Gå till startsidan för Mina sidor</a>
          </p>
        </OffApp>
        <OnApp>
          <Button
            type="secondary"
            onClick={handleGoToInventory}
            text="Gå till din parkering"
          />
        </OnApp>
      </Ver>
    {:else}
      <EmptyState
        title="Här var det tomt"
        message="Här finns det inget att se. Förmodligen har du fått en trasig länk av någon"
      ></EmptyState>
    {/if}
  {/snippet}
</Page>
